// extracted by mini-css-extract-plugin
module.exports = {"AINote":"AINote_AINote__5AdEZ","loading":"AINote_loading__QsmnO"};